// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.size-36 {\n  height: 36px !important;\n  width: 36px !important;\n}\n", ""]);
// Exports
module.exports = exports;
